import { Tab as HuiTab, TabProps as HuiTabProps } from '@headlessui/react';
import { FC } from 'react';
import { cx } from '@/utils/cx';

export type TabProps = HuiTabProps;

export const Tab: FC<TabProps> = ({ children, className, ...props }) => (
  <HuiTab
    className={cx(
      'focusable',
      'data-[selected]:border-b-2 data-[selected]:border-b-primary data-[selected]:pb-3.5 data-[selected]:text-primary',
      '-mb-[1px] py-4 text-sm font-medium text-gray-500',
      className,
    )}
    {...props}
  >
    {children}
  </HuiTab>
);
